import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';
import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';

export class AssetStorageMimeType extends PrimitiveValueObject<string> {
  static create(value: string): AssetStorageMimeType {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new AssetStorageMimeType(value);
  }
}
